"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PREFIX = exports.AuthLoginByOtacHelper = exports.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = exports.AUTH_FAILURE_LOGIN_MESSAGE_NAME = void 0;
exports.formatUserData = formatUserData;
exports.subscribeOnLoginSuccess = exports.subscribeOnLoginFailure = exports.openAuthLoginUrlByOtac = exports.getSilentSignInVerifyUrl = exports.getSilentSignInUrl = exports.getSignupUrl = exports.getLogoutUrl = exports.getLoginUrl = exports.getLoadingUrl = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _auth = require("./errors/auth");
var _excluded = ["given_name", "family_name"];
var DEFAULT_PREFIX = "/openid/v2";
exports.DEFAULT_PREFIX = DEFAULT_PREFIX;
var AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = "AUTH_PAGE_SUCCESSFULL_LOGIN";
exports.AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME;
var AUTH_FAILURE_LOGIN_MESSAGE_NAME = "AUTH_PAGE_FAILURE_LOGIN";

// eslint-disable-next-line @typescript-eslint/no-namespace

/**
 * @deprecated Use AuthLoginByOtacHelper. Remove on next major
 */
exports.AUTH_FAILURE_LOGIN_MESSAGE_NAME = AUTH_FAILURE_LOGIN_MESSAGE_NAME;
var USER_CLAIMS = ["email", "phone_number", "exp", "expires", "name", "nickname", "preferred_username", "role", "sub", "given_name", "family_name", "avatar"];

/**
 * Cleanup user secret data
 * @param data - user data
 * @param keys - accepted keys
 * @returns IPublicUser - clean user data
 */
function formatUserData(data, keys) {
  if (keys === void 0) {
    keys = [];
  }
  var user = (0, _pick2.default)(data, [].concat(USER_CLAIMS, keys));
  // eslint-disable-next-line @typescript-eslint/naming-convention
  var given_name = user.given_name,
    family_name = user.family_name,
    rest = (0, _objectWithoutPropertiesLoose2.default)(user, _excluded);
  return (0, _extends2.default)({}, rest, given_name ? {
    first_name: given_name
  } : {}, family_name ? {
    last_name: family_name
  } : {});
}
var getLoginUrl = function getLoginUrl(options) {
  var _ref = options || {},
    webPath = _ref.webPath,
    returnUrl = _ref.returnUrl,
    loginType = _ref.loginType,
    _ref$isNewWindow = _ref.isNewWindow,
    isNewWindow = _ref$isNewWindow === void 0 ? false : _ref$isNewWindow,
    otac = _ref.otac,
    ot = _ref.ot,
    acr_values = _ref.acr_values,
    hint = _ref.hint,
    prompt = _ref.prompt,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? DEFAULT_PREFIX : _ref$prefix;
  var hasWebPath = Boolean(webPath);
  var loginUrl = new URL(prefix + "/login/", hasWebPath ? webPath : "http://test.com");
  if (returnUrl) {
    loginUrl.searchParams.append("returnUrl", returnUrl);
  }
  if (loginType) {
    loginUrl.searchParams.append("loginType", loginType);
  }
  if (ot) {
    loginUrl.searchParams.append("ot", ot);
  }
  if (otac) {
    loginUrl.searchParams.append("otac", otac);
  }
  if (acr_values) {
    loginUrl.searchParams.append("acr_values", acr_values);
  }
  if (hint) {
    loginUrl.searchParams.append("hint", hint);
  }
  if (prompt) {
    loginUrl.searchParams.append("prompt", prompt);
  }
  if (isNewWindow) {
    loginUrl.searchParams.append("type", "popup");
  }
  return hasWebPath ? loginUrl.toString() : "" + loginUrl.pathname + loginUrl.search;
};
exports.getLoginUrl = getLoginUrl;
var getSignupUrl = function getSignupUrl(options) {
  var _ref2 = options || {},
    webPath = _ref2.webPath,
    _ref2$prefix = _ref2.prefix,
    prefix = _ref2$prefix === void 0 ? DEFAULT_PREFIX : _ref2$prefix,
    _ref2$isNewWindow = _ref2.isNewWindow,
    isNewWindow = _ref2$isNewWindow === void 0 ? false : _ref2$isNewWindow,
    hint = _ref2.hint,
    code = _ref2.code,
    returnUrl = _ref2.returnUrl;
  var hasWebPath = Boolean(webPath);
  var signupUrl = new URL(prefix + "/signup/", hasWebPath ? webPath : "http://test.com");
  if (code) {
    signupUrl.searchParams.append("code", code);
  }
  if (returnUrl) {
    signupUrl.searchParams.append("returnUrl", returnUrl);
  }
  if (hint) {
    signupUrl.searchParams.append("hint", hint);
  }
  if (isNewWindow) {
    signupUrl.searchParams.append("type", "popup");
  }
  return hasWebPath ? signupUrl.toString() : "" + signupUrl.pathname + signupUrl.search;
};
exports.getSignupUrl = getSignupUrl;
var getLogoutUrl = function getLogoutUrl(options) {
  var _ref3 = options || {},
    webPath = _ref3.webPath,
    _ref3$prefix = _ref3.prefix,
    prefix = _ref3$prefix === void 0 ? DEFAULT_PREFIX : _ref3$prefix,
    _ref3$isNewWindow = _ref3.isNewWindow,
    isNewWindow = _ref3$isNewWindow === void 0 ? false : _ref3$isNewWindow,
    returnUrl = _ref3.returnUrl;
  var hasWebPath = Boolean(webPath);
  var logoutUrl = new URL(prefix + "/logout/", hasWebPath ? webPath : "http://test.com");
  if (returnUrl) {
    logoutUrl.searchParams.append("returnUrl", returnUrl);
  }
  if (isNewWindow) {
    logoutUrl.searchParams.append("type", "popup");
  }
  return hasWebPath ? logoutUrl.toString() : "" + logoutUrl.pathname + logoutUrl.search;
};
exports.getLogoutUrl = getLogoutUrl;
var getLoadingUrl = function getLoadingUrl(options) {
  var _ref4 = options || {},
    webPath = _ref4.webPath,
    _ref4$prefix = _ref4.prefix,
    prefix = _ref4$prefix === void 0 ? DEFAULT_PREFIX : _ref4$prefix;
  var hasWebPath = Boolean(webPath);
  var loadingUrl = new URL(prefix + "/loading/", hasWebPath ? webPath : "http://test.com");
  return hasWebPath ? loadingUrl.toString() : "" + loadingUrl.pathname + loadingUrl.search;
};
exports.getLoadingUrl = getLoadingUrl;
var getSilentSignInUrl = function getSilentSignInUrl(options) {
  var _ref5 = options || {},
    webPath = _ref5.webPath,
    _ref5$prefix = _ref5.prefix,
    prefix = _ref5$prefix === void 0 ? DEFAULT_PREFIX : _ref5$prefix;
  var hasWebPath = Boolean(webPath);
  var silentSignInUrl = new URL(prefix + "/silent/signin/", hasWebPath ? webPath : "http://test.com");
  return hasWebPath ? silentSignInUrl.toString() : "" + silentSignInUrl.pathname;
};
exports.getSilentSignInUrl = getSilentSignInUrl;
var getSilentSignInVerifyUrl = function getSilentSignInVerifyUrl(options) {
  var _ref6 = options || {},
    webPath = _ref6.webPath,
    _ref6$prefix = _ref6.prefix,
    prefix = _ref6$prefix === void 0 ? DEFAULT_PREFIX : _ref6$prefix;
  var hasWebPath = Boolean(webPath);
  var silentSignInVerifyUrl = new URL(prefix + "/silent/signin/verify/", hasWebPath ? webPath : "http://test.com");
  return hasWebPath ? silentSignInVerifyUrl.toString() : "" + silentSignInVerifyUrl.pathname;
};

// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginSuccess
exports.getSilentSignInVerifyUrl = getSilentSignInVerifyUrl;
var subscribeOnLoginSuccess = function subscribeOnLoginSuccess(callback) {
  var _sravni$authenticatio, _sravni;
  if (typeof window === "undefined") {
    return function () {};
  }
  var uniqSymbol = Symbol("Uniq key for post message handler work");
  window.sravni = (0, _extends2.default)({}, window.sravni, {
    authentication: (0, _extends2.default)({}, (_sravni$authenticatio = (_sravni = window.sravni) == null ? void 0 : _sravni.authentication) != null ? _sravni$authenticatio : {}, {
      loginSuccessPostMessageSymbol: uniqSymbol
    })
  });
  var handler = function handler(event) {
    var canExecuteCallback = window.sravni.authentication.loginSuccessPostMessageSymbol === uniqSymbol;
    if (!canExecuteCallback) {
      return false;
    }
    var message = event.data;
    var sourceWindow = event.source;
    if (typeof message.authMessageType !== "undefined" && message.authMessageType === AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME && typeof message !== "undefined" && message.payload === true) {
      if (sourceWindow && sourceWindow.constructor.name === "Window") sourceWindow.close();
      callback();
    }
  };
  window.addEventListener("message", handler, false);
  return function () {
    window.sravni.authentication.loginSuccessPostMessageSymbol = undefined;
    window.removeEventListener("message", handler, false);
  };
};

// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginFailure
exports.subscribeOnLoginSuccess = subscribeOnLoginSuccess;
var subscribeOnLoginFailure = function subscribeOnLoginFailure(callback) {
  var _sravni$authenticatio2, _sravni2;
  if (typeof window === "undefined") {
    return function () {};
  }
  var uniqSymbol = Symbol("Uniq key for post message handler work");
  window.sravni = (0, _extends2.default)({}, window.sravni, {
    authentication: (0, _extends2.default)({}, (_sravni$authenticatio2 = (_sravni2 = window.sravni) == null ? void 0 : _sravni2.authentication) != null ? _sravni$authenticatio2 : {}, {
      loginFailurePostMessageSymbol: uniqSymbol
    })
  });
  var handler = function handler(event) {
    var canExecuteCallback = window.sravni.authentication.loginFailurePostMessageSymbol === uniqSymbol;
    if (!canExecuteCallback) {
      return false;
    }
    var message = event.data;
    if (typeof message.authMessageType !== "undefined" && message.authMessageType === AUTH_FAILURE_LOGIN_MESSAGE_NAME && typeof message !== "undefined" && message.payload === true) {
      callback();
    }
  };
  window.addEventListener("message", handler, false);
  return function () {
    window.sravni.authentication.loginFailurePostMessageSymbol = undefined;
    window.removeEventListener("message", handler, false);
  };
};

/**
 * @deprecated Use AuthLoginByOtacHelper. Remove on next major
 */
exports.subscribeOnLoginFailure = subscribeOnLoginFailure;
var openAuthLoginUrlByOtac = function openAuthLoginUrlByOtac(params) {
  if (typeof window === "undefined") return null;
  var getSilentAuthModalParameters = function getSilentAuthModalParameters(width, height) {
    var getSilentAuthModalPosition = function getSilentAuthModalPosition(width, height) {
      if (typeof window === "undefined") return null;

      // Fixes dual-screen position                             Most browsers      Firefox
      var screenDualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      var screenDualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
      var screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
      var top = (screenHeight - height) / 2 + screenDualTop;
      var left = (screenWidth - width) / 2 + screenDualLeft;
      return {
        top,
        left
      };
    };
    var modalPosition = getSilentAuthModalPosition(width, height);
    return "width=" + width + ", height=" + height + ", top=" + (modalPosition ? modalPosition.top : 0) + ", left=" + (modalPosition ? modalPosition.left : 0);
  };
  var otac = params.otac,
    hint = params.hint,
    prefix = params.prefix,
    webPath = params.webPath,
    type = params.type,
    _params$width = params.width,
    width = _params$width === void 0 ? 430 : _params$width,
    _params$height = params.height,
    height = _params$height === void 0 ? 600 : _params$height,
    onSuccess = params.onSuccess,
    _params$onError = params.onError,
    onError = _params$onError === void 0 ? function () {} : _params$onError;
  var isNewWindow = ["modal", "tab"].includes(type);
  var target = isNewWindow ? "_blank" : "_self";
  var features = ["modal"].includes(type) ? getSilentAuthModalParameters(width, height) : undefined;
  var loginUrl = getLoginUrl({
    otac,
    hint,
    prefix,
    webPath,
    loginType: "otac",
    isNewWindow,
    // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
    prompt: "login"
  });
  subscribeOnLoginSuccess(onSuccess);

  // Хак для сафари. Открытие окна происходит в синхронном коде
  setTimeout(function () {
    var handle = window.open(loginUrl, target, features);
    if (!handle) {
      onError(new Error("Modal window was blocked by browser"));
    }
  }, 0);
};

/*
 * Helper for login by otac.
 * Solves problems: window modal size, window modal position, blocking window modal by browser.
 */
exports.openAuthLoginUrlByOtac = openAuthLoginUrlByOtac;
var AuthLoginByOtacHelper = /*#__PURE__*/function () {
  function AuthLoginByOtacHelper(params) {
    this.params = params;
  }
  var _proto = AuthLoginByOtacHelper.prototype;
  _proto._getWindowFeatures = function _getWindowFeatures(width, height) {
    var getSilentAuthModalPosition = function getSilentAuthModalPosition(width, height) {
      if (typeof window === "undefined") return null;

      // Fixes dual-screen position                             Most browsers      Firefox
      var screenDualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      var screenDualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
      var screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
      var screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
      var top = (screenHeight - height) / 2 + screenDualTop;
      var left = (screenWidth - width) / 2 + screenDualLeft;
      return {
        top,
        left
      };
    };
    var modalPosition = getSilentAuthModalPosition(width, height);
    return "width=" + width + ", height=" + height + ", top=" + (modalPosition ? modalPosition.top : 0) + ", left=" + (modalPosition ? modalPosition.left : 0);
  };
  _proto._getWindowParams = function _getWindowParams() {
    var _this$params = this.params,
      type = _this$params.type,
      _this$params$width = _this$params.width,
      width = _this$params$width === void 0 ? 430 : _this$params$width,
      _this$params$height = _this$params.height,
      height = _this$params$height === void 0 ? 600 : _this$params$height;
    var isNewWindow = ["modal", "tab"].includes(type);
    var target = isNewWindow ? "_blank" : undefined;
    var features = ["modal"].includes(type) ? this._getWindowFeatures(width, height) : undefined;
    return {
      isNewWindow,
      target,
      features
    };
  };
  _proto._startChildWindowCloseWatcher = function _startChildWindowCloseWatcher(callback) {
    var _this = this;
    if (typeof window === "undefined") return undefined;
    if (!this._childWindow) return undefined;
    return setInterval(function () {
      if (!_this._childWindow || _this._childWindow.window === null || _this._childWindow.window === undefined || _this._childWindow.closed) {
        callback();
      }
    }, 500);
  };
  _proto._startChildWindowTimeoutWatcher = function _startChildWindowTimeoutWatcher(timeout, callback) {
    if (typeof window === "undefined") return undefined;
    if (!this._childWindow) return undefined;
    return setTimeout(function () {
      callback();
    }, timeout);
  }

  /*
   * Must be called AFTER user action and BEFORE long js task (like ajax request)
   */;
  _proto.prepare = function prepare(params) {
    var _this2 = this;
    if (typeof window === "undefined") return undefined;
    var _ref7 = params || {},
      _ref7$timeout = _ref7.timeout,
      timeout = _ref7$timeout === void 0 ? 10000 : _ref7$timeout,
      onError = _ref7.onError;
    var _this$params2 = this.params,
      _this$params2$window = _this$params2.window,
      _this$params2$window2 = _this$params2$window === void 0 ? {} : _this$params2$window,
      _this$params2$window3 = _this$params2$window2.title,
      title = _this$params2$window3 === void 0 ? "Вход на сайт | Сравни.ру" : _this$params2$window3,
      prefix = _this$params2.prefix,
      webPath = _this$params2.webPath;
    var _this$_getWindowParam = this._getWindowParams(),
      target = _this$_getWindowParam.target,
      features = _this$_getWindowParam.features;
    var loadingUrl = getLoadingUrl({
      prefix,
      webPath
    });

    // Сафари ругается при исполнении этого кода - window.open внутри async
    // Сафари не дает открыть новое окно если функция 'prepare' лежит в обработчике события. ОТ этого спасает setTimeout
    setTimeout(function () {
      var childWindow = window.open(loadingUrl, target, features);
      if (!childWindow) {
        // Так как код выполняется в setTimeout - то выбрасывание исключения через throw не будет перехвачено try catch над методом prepare
        if (typeof onError === "function") {
          onError(new _auth.AuthWindowBlockedError());
          return;
        }
        throw new _auth.AuthWindowBlockedError();
      }
      _this2._childWindow = childWindow;
      _this2._childWindow.document.title = title;
      _this2._startChildWindowTimeoutWatcher(timeout, function () {
        return _this2.destroy();
      });

      // Хак. не уверен что он работает
      window.blur();
      setTimeout(window.focus, 0);
    }, 0);
  };
  _proto.destroy = function destroy() {
    var _this3 = this;
    if (typeof window === "undefined") return undefined;

    // При вызове этого кода синхронно сафари на ios теряет указатель на this._childWindow
    // А при отложенном вызове он есть
    setTimeout(function () {
      if (!_this3._childWindow) {
        return undefined;
      }
      _this3._childWindow.close();
      _this3._childWindow = undefined;
    }, 0);
  }

  /*
   * Implements login and error handling
   */;
  _proto.login = function login(params) {
    var _this4 = this;
    if (typeof this._childWindow === "undefined") {
      throw new Error('No window defined. Call method "prepare" first');
    }
    var _this$params3 = this.params,
      prefix = _this$params3.prefix,
      webPath = _this$params3.webPath;
    var otac = params.otac,
      hint = params.hint;
    var _this$_getWindowParam2 = this._getWindowParams(),
      isNewWindow = _this$_getWindowParam2.isNewWindow;
    var url = getLoginUrl({
      otac,
      hint,
      prefix,
      webPath,
      loginType: "otac",
      isNewWindow,
      // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
      prompt: "login"
    });
    return new Promise(function (resolve, reject) {
      var childWindowCloseWatcherId = _this4._startChildWindowCloseWatcher(function () {
        clearInterval(childWindowCloseWatcherId);
        reject(new _auth.AuthWindowClosedError());
      });
      subscribeOnLoginSuccess(function () {
        clearInterval(childWindowCloseWatcherId);
        _this4.destroy();
        resolve(undefined);
      });
      subscribeOnLoginFailure(function () {
        clearInterval(childWindowCloseWatcherId);
        _this4.destroy();
        reject(new _auth.AuthError());
      });
      if (_this4._childWindow) {
        _this4._childWindow.location.href = url;

        // Хак. не уверен что он работает
        _this4._childWindow.blur();
        setTimeout(_this4._childWindow.focus, 0);
      }
    });
  };
  return AuthLoginByOtacHelper;
}();
exports.AuthLoginByOtacHelper = AuthLoginByOtacHelper;